import CMSPage from "./CMSPage.tsx";
import { PageContextValue } from "./engine/CMSComponent.tsx";
import type { RenderContext } from "./types.ts";
import "./styles.css";

export default function App({ renderContext }: { renderContext: RenderContext }) {
  const { pageModel, pageContext, site, year } = renderContext;

  return (
    <PageContextValue.Provider value={pageContext}>
      <CMSPage
        pageModel={pageModel}
        site={site}
        year={year}
        render={({ header, body, footer, belowFooter }) => (
          <div className="cms-layout">
            <header className="cms-header">{header}</header>
            <main>{body}</main>
            <footer className="cms-footer">{footer}</footer>
            {belowFooter}
          </div>
        )}
      />
    </PageContextValue.Provider>
  );
}
